import CrudCustom from '../../../libs/custom/CrudCustom';

let ReturPenjualanPosService = new CrudCustom('/pos-transaksi-retur-penjualans');
export default ReturPenjualanPosService;
